import React, { useRef, useState } from 'react';
import { Button, message, Modal } from 'antd';
import { IoIosArrowForward } from 'react-icons/io';
import { BsCheckCircle } from 'react-icons/bs';
import { dispatch, useGlobalState } from '../../../store/state';
import PlatformIconRender from '../../Common/PlatformIconRender';
import {
  LoginSocialFacebook,
  LoginSocialGoogle,
} from 'reactjs-social-login';
import { ConnectInstagram, unlinkInstagramAPI } from '../../../apis/Influencer/Socials/ConnectInstagram';
import { ConnectYoutube } from '../../../apis/Influencer/Socials/ConnectYoutube';
import { GetTwitterToken } from '../../../apis/Influencer/Socials/GetTwitterToken';
import { Config } from '../../../Config';
import { useHistory } from 'react-router-dom';

const ProfilePlatformsComponent = ({ setCurrentTab, refreshProfile }) => {
  // const location = useLocation()
  const [user] = useGlobalState('user');
  const [tOauthData] = useGlobalState('tOauthData');
  const instaButtonRef = useRef();
  const history = useHistory();
  const [instaData, setInstaData]= useState({
    client_id: Config.social.fb.client_id,
    redirect_uri: Config.social.fb.redirect_uri,
    scope: Config.social.fb.scope,
    version: Config.social.fb.version,
    trigger: false,
    responseData: {},
  });
  const [youtubeData, setYoutubeData] = useState({
    client_id: Config.social.yt.client_id,
    trigger: false,
    responseData: {},
  });

  const linkTwitter = () => {
    GetTwitterToken(user.accessToken).then(({ status, response }) =>{
      console.log('twitter Data', response);
      if (status === 200) {
        dispatch({
          type: 'SET_T_OAUTH',
          payload: {
            ...tOauthData,
            ...response,
          },
        });
        setTimeout(()=>{
          startTwitterProcess(response);
        }, [1000]);
      } else {
        message.error('there is some issue while requesting Twitter URL');
      }
    });

    // @note: trigger twitter Redirect
    const startTwitterProcess = (res) =>{
      (async () => {
        try {
          window.location.href = res.authorizationUrl;
        } catch (error) {
          console.error(error);
        }
      })();
    };
  };
  const linkInstagram = (data) => {
    console.log('youtube data', youtubeData);
    // const {responseData} = data
    // const {responseData} = instaData
    const _data = {
      InstagramId: data.userID,
      InstagramAccessToken: data.accessToken,
    };
    ConnectInstagram(user.accessToken, _data).then(({ status, response })=>{
      console.log('API: get youtube login reponse ==>', response);
      if (status === 200) {
        message.success('Instagram Linked successfully');
        setTimeout(()=>{
          refreshProfile();
          history.push('/influencer');
        }, 200);
      } else {
        if (response?.errors?.[0]?.msg) {
          message.error(response.errors[0].msg);
        } else {
          message.error('There is some issue while Connecting Instagram');
        }
      }
    });
  };
  const linkYoutube = () => {
    console.log('youtube data', youtubeData);
    const { responseData } = youtubeData;
    const _data = { YtAccessToken: responseData.data.access_token };
    ConnectYoutube(user.accessToken, _data).then(({ status, response })=>{
      console.log('API: get youtube login reponse ==>', response);
      if (status === 200) {
        message.success('Youtube Linked successfully');
        setTimeout(()=>{
          refreshProfile();
        }, 200);
      } else {
        message.error('there is some issue while Connecting Youtube');
      }
    });
  };

  const unlinkInstagram = () => {
    Modal.confirm({
      title: 'Are you sure to unlink Instagram?',
      content: '',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk () {
        unlinkInstagramAPI(user.accessToken).then(({ status, response })=>{
          console.log('API: get youtube login reponse ==>', response);
          if (status === 200) {
            message.success('Instagram Unlinked successfully');
            setTimeout(()=>{
              refreshProfile();
            }, 200);
          } else {
            message.error('there is some issue while Connecting Instagram');
          }
        });
      },
      onCancel () {
        console.log('Cancel');
      },
    });
  };

  const triggerInstaNotes = () =>{
    Modal.confirm({
      title: (<h5 className="common_title"><strong>Before Proceeds to connect Instagram</strong></h5>),
      width: 550,
      content: (<>
        <ol className="pl-3">
          <li>
            <p className="m-0"><strong>Influencer Instagram account should be either a creator account / businness account.</strong></p>
            <p>To achive this you will have to go to settings &gt; switch accounts and choose the appropriate option</p>
          </li>
          <li>
            <p><strong>Then you will have to create a FB page if you don't have</strong></p>
          </li>
          <li>
            <p><strong>Link the IG account to FB Page of your choice.</strong></p>
          </li>
          <li>
            <p><strong>Once all above points satisfied from your end then you can proceed with connecting to flynt</strong></p>
          </li>
        </ol>
      </>),
      okText:
            <LoginSocialFacebook
              appId={instaData.client_id}
              redirect_uri={instaData.redirect_uri}
              scope={instaData.scope}
              version={instaData.version}
              onResolve={({ provider, data }) => {
                setInstaData({
                  ...instaData,
                  responseData: data,
                });
                linkInstagram(data);
                console.log('data insta', JSON.stringify(data));
              }}
              onReject={(err) => console.log('err', err)}
            >
              <div ref={instaButtonRef} >Yes, am ready to Proceed</div>
            </LoginSocialFacebook>,
      onOk: () =>{
        console.log('user Ready');
        setInstaData({
          ...instaData,
          trigger: true,
        });
        setTimeout(()=>{
          console.log('ref', instaButtonRef.current);
          instaButtonRef.current.click();
        }, [100]);
      },
      // cancelText:"Yes, am ready to proceed"
    });
  };

  // useEffect(() => {

  // }, [instaData.trigger])

  return (
    <div className="prof_widget_platforms">
      <div className="row">
        <div className="col-12">
          <h4>Connect your platforms</h4>
          <p className="m-0">Sign in to your account and show off your to the world with Flynt</p>
        </div>
        <div className="col-md-4">
          <div className="prof_widget_platforms_connect">
            {user.instagram_account.enabled?(
              <div className="pre_card">
                <h5 className="pre_card--title pr-5"><BsCheckCircle color="green"
                  size={18}
                  className="mr-2" /> Connected to Instagram <span><PlatformIconRender platform="instagram"
                  className="mr-2"/></span></h5>
                <p className="pre_card--desc">Your instagram account is connected to us. We will make sure your data will be secure.</p>
                <Button className="common_button outlined small py-2"
                  onClick={unlinkInstagram}
                  danger>Unlink Instagram</Button>
              </div>
            ):(
              <div className="pre_card">
                <h5 className="pre_card--title pr-5">Connect Instagram Account <span><PlatformIconRender platform="instagram"
                  className="mr-2"/></span></h5>
                <p className="pre_card--desc">Share the joy of giving and make a positive impact on your community with our campaign</p>
                <div className="text-left">{
                  <Button className="common_button outlined small py-2"
                    onClick={triggerInstaNotes}>Connect Instagram</Button>

                }
                </div>
              </div>
            )
            }
          </div>
        </div>
        <div className="col-md-4">
          <div className="prof_widget_platforms_connect">
            {
              user.twitter_account.enabled?(
                <div className="pre_card">
                  <h5 className="pre_card--title pr-5"><BsCheckCircle color="green"
                    size={18}
                    className="mr-2" /> Connected to Twitter <span><PlatformIconRender platform="twitter"
                    className="mr-2"/></span></h5>
                  <p className="pre_card--desc">Your Twitter account is connected to us. We will make sure your data will be secure.</p>
                  <Button className="common_button  outlined small py-2"
                    danger>Unlink Twitter</Button>
                </div>
              ):(
                <div className="pre_card">
                  <h5 className="pre_card--title pr-5">Connect Twitter Account <span><PlatformIconRender platform="twitter"
                    className="mr-2"/></span></h5>
                  <p className="pre_card--desc">Share the joy of giving and make a positive impact on your community with our campaign</p>
                  <div className="text-left">
                    <Button className="common_button  outlined small py-2"
                      disabled
                      onClick={linkTwitter}>Connect Twitter</Button>
                  </div>
                </div>
              )
            }
          </div>
        </div>

        <div className="col-md-4">
          <div className="prof_widget_platforms_connect">
            {user.youtube_account.enabled?(
              <div className="pre_card">
                <h5 className="pre_card--title pr-5"><BsCheckCircle color="green"
                  size={18}
                  className="mr-2" /> Connected to Youtube <span><PlatformIconRender platform="youtube"
                  className="mr-2"/></span></h5>
                <p className="pre_card--desc">Your youtube account is connected to us. We will make sure your data will be secure.</p>
                <Button className="common_button  outlined small py-2"
                  danger >Unlink Youtube</Button>
              </div>
            ):(
              <div className="pre_card">
                <h5 className="pre_card--title pr-5">Connect Youtube Account <span><PlatformIconRender platform="youtube"
                  className="mr-2"/></span></h5>
                <p className="pre_card--desc">Share the joy of giving and make a positive impact on your community with our campaign</p>
                <div className="text-left">
                  <LoginSocialGoogle
                    client_id={youtubeData.client_id}
                    access_type={Config.social.yt.access_type}
                    scope={Config.social.yt.scope}
                    onResolve={({ data }) => {
                      setYoutubeData({
                        ...youtubeData,
                        responseData: data,
                      });
                      linkYoutube();
                      console.log('Google response Data', JSON.stringify(data));
                    }}
                    onReject={(err) => {
                      message.error('Youtube linking failed!');
                      console.log(err);
                    }}
                  >
                    <Button className="common_button outlined small py-2"
                      disabled>Connect Youtube</Button>
                  </LoginSocialGoogle>
                </div>
              </div>
            )
            }
          </div>
        </div>
        <div className="col-md-12 text-right">
          <span className="ml-3">
            <Button className="common_button outlined"
              onClick={() => setCurrentTab('2')}>Interests <IoIosArrowForward className="ml-2"/></Button>
          </span>
        </div>
      </div>
    </div>
  );
};

export default ProfilePlatformsComponent;
